import { addDays, mondayOf, todayIso } from './dates';

const block = (id, phaseId, start, span) => ({ id, phaseId, start, span });

// Two demo roadmaps in the app's v3 format. Dates are worked out from today, so the Today line,
// the dated sprint headers and the milestones always land in the visible timeline.
export function sampleRoadmaps(now = new Date()) {
  const start = mondayOf(todayIso(now));
  return [
    {
      schemaVersion: 3,
      id: 'demo-q3-platform',
      name: 'Platform',
      createdAt: '2026-07-01T09:00:00.000Z',
      updatedAt: '2026-07-01T09:00:00.000Z',
      settings: { sprintCount: 6, halfSprints: false, startDate: start, sprintLengthDays: 14 },
      members: [
        { id: 'priya', name: 'Priya Shah' },
        { id: 'tom', name: 'Tom Reid', capacity: 80 },
        { id: 'ana', name: 'Ana Costa', away: [6] },
        { id: 'sam', name: 'Sam Okafor' }
      ],
      milestones: [
        { id: 'm-beta', name: 'Beta launch', slot: 8, date: addDays(start, 56) },
        { id: 'm-pilot', name: 'Enterprise pilot', slot: 11, date: addDays(start, 77) }
      ],
      phases: [
        { id: 'discovery', name: 'Discovery', color: 'teal' },
        { id: 'design', name: 'Design', color: 'purple' },
        { id: 'build', name: 'Build', color: 'blue' },
        { id: 'release', name: 'Release', color: 'green' }
      ],
      projects: [
        {
          id: 'onboarding',
          name: 'Rebuild onboarding flow',
          description: 'Shorter sign-up and a guided first run.',
          group: 'Core product',
          status: 'committed',
          memberIds: ['priya', 'ana'],
          blocks: [block('o1', 'discovery', 0, 2), block('o2', 'design', 2, 2), block('o3', 'build', 6, 4)]
        },
        {
          id: 'billing',
          name: 'Migrate billing to Stripe',
          description: '',
          group: 'Enterprise',
          status: 'committed',
          memberIds: ['tom', 'sam'],
          allocation: { sam: 60, tom: 40 },
          links: [{ id: 'l-billing', label: 'Migration plan', url: 'https://example.com/billing-plan' }],
          blocks: [block('b1', 'build', 2, 6), block('b2', 'release', 8, 2)]
        },
        {
          id: 'sso',
          name: 'SSO for enterprise tier',
          description: '',
          group: 'Enterprise',
          status: 'likely',
          memberIds: ['sam', 'priya'],
          dependsOn: ['billing'],
          blocks: [block('s1', 'discovery', 4, 2), block('s2', 'build', 6, 2)]
        },
        {
          id: 'dark-mode',
          name: 'Dark mode for all accounts',
          description: '',
          group: 'Core product',
          status: 'committed',
          memberIds: ['ana'],
          blocks: [block('d1', 'design', 0, 2), block('d2', 'build', 2, 4), block('d3', 'release', 8, 2)]
        },
        {
          id: 'csv',
          name: 'CSV export for reports',
          description: '',
          group: 'Core product',
          status: 'exploratory',
          memberIds: ['tom'],
          allocation: { tom: 40 },
          blocks: [block('c1', 'build', 6, 2)]
        }
      ]
    },
    {
      schemaVersion: 3,
      id: 'demo-growth',
      name: 'Growth experiments',
      createdAt: '2026-06-01T09:00:00.000Z',
      updatedAt: '2026-06-01T09:00:00.000Z',
      // Starts one sprint later, so Compare lines the two roadmaps up by date.
      settings: { sprintCount: 6, halfSprints: true, startDate: addDays(start, 14), sprintLengthDays: 14 },
      members: [
        { id: 'g-priya', name: 'Priya Shah' },
        { id: 'jess', name: 'Jess Lin' },
        { id: 'dev', name: 'Dev Patel' }
      ],
      phases: [
        { id: 'research', name: 'Research', color: 'amber' },
        { id: 'experiment', name: 'Experiment', color: 'rose' },
        { id: 'launch', name: 'Launch', color: 'green' }
      ],
      projects: [
        {
          id: 'pricing',
          name: 'Pricing page test',
          description: '',
          status: 'committed',
          memberIds: ['jess', 'g-priya'],
          blocks: [block('p1', 'research', 2, 2), block('p2', 'experiment', 4, 3)]
        },
        {
          id: 'referrals',
          name: 'Referral programme',
          description: '',
          status: 'likely',
          memberIds: ['dev'],
          blocks: [block('r1', 'research', 5, 2), block('r2', 'launch', 9, 2)]
        },
        {
          id: 'funnel',
          name: 'Quote funnel tweaks',
          description: '',
          status: 'exploratory',
          memberIds: ['jess', 'dev'],
          blocks: [block('f1', 'experiment', 7, 2)]
        }
      ]
    }
  ];
}
